import React from 'react'
import toDegree from 'helpers/toDegree'
import { CORRIDOR } from 'helpers/globals'
import calculateVertex from './helpers/calculateVertex'
import calculateMaxVerticalAngleOfView from 'helpers/calculations/calculateMaxVerticalAngleOfView'

class AngleMarkers extends React.Component {
  constructor(props) {
    super(props)
    this.angle = this.props.angle
  }

  maxVFoV = _ => calculateMaxVerticalAngleOfView({ aspectRatio: this.props.aspectRatio })

  componentWillMount() {
    const { paths: { leftPosition, rightPosition }, map, addToMarkers } = this.props

    this.leftMarker = new google.maps.Marker({
      position: leftPosition,
      icon: {
        url: 'https://maps.google.com/mapfiles/kml/pal4/icon57.png',
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 15),
        scaledSize: new google.maps.Size(30, 30)
      },
      zIndex: 102,
      draggable: true,
      visible: this.isVisible(this.props),
      map
    })

    this.rightMarker = new google.maps.Marker({
      position: rightPosition,
      icon: {
        url: 'https://maps.google.com/mapfiles/kml/pal4/icon57.png',
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 15),
        scaledSize: new google.maps.Size(30, 30)
      },
      zIndex: 102,
      draggable: true,
      visible: this.isVisible(this.props),
      map
    })

    addToMarkers('leftAngle', this.leftMarker)
    addToMarkers('rightAngle', this.rightMarker)

    ;['right', 'left'].forEach(function(side) {
      google.maps.event.addDomListener(
        this[`${side}Marker`],
        'drag',
        e => this.updateMarkers(e.latLng, side)
      )

      google.maps.event.addDomListener(
        this[`${side}Marker`],
        'dragend',
        e => {
          if (this.cameraIsCorridorAndAngleIsPastMaximum()) this.calculateMaxVertexAndUpdateMarker(side, this.angle)
          this.updateMarkers(e.latLng, side)
          this.props.setAngleMarkerDragging(false)
        }
      )

      google.maps.event.addDomListener(
        this[`${side}Marker`],
        'dragstart',
        _ => this.props.setAngleMarkerDragging(true)
      )
    }, this)
  }

  updateMarkers = (latLng, side) => {
    const { pos, oppositePos } = this.calculateMarkersLocation(latLng, side)
    const { cameraIsCorridorAndAngleIsPastMaximum, calculateMaxVertexAndUpdateMarker,
      cameraModelHasRange, angleWhenLimitIsBroke,
      props: { updateAngle, model, fovMode } } = this

    // set the current angle for internal use, namely on 'dragend' callbacks
    this.angle = this.calculateAngleOfView(pos, oppositePos)

    // if you go past the limit, don't set the positions of the markers
    if (cameraModelHasRange() && angleWhenLimitIsBroke(fovMode, this.angle, model)) {
      const limit = angleWhenLimitIsBroke(fovMode, this.angle, model)
      calculateMaxVertexAndUpdateMarker(side, limit)
      updateAngle(limit)
      this.props.messageAction('generalError', `Camera model restricted to ${limit}°`)
      return
    } else if (cameraIsCorridorAndAngleIsPastMaximum()) {
      calculateMaxVertexAndUpdateMarker(side, this.maxVFoV())
      updateAngle(this.maxVFoV())
      this.props.messageAction('generalError', 'Switch to conventional for wider AoV.')
      return
    }

    // set positions
    this.rightMarker.setPosition(pos)
    this.leftMarker.setPosition(oppositePos)
    // set angle of camera based on new position of marker
    updateAngle(this.angle)
  }

  cameraIsCorridor = _ => this.props.fovMode === CORRIDOR

  cameraIsCorridorAndAngleIsPastMaximum = _ => this.cameraIsCorridor() && this.angle > this.maxVFoV()

  cameraModelHasRange = _ => this.props.model && this.props.model.aov && this.props.model.aov.max

  angleWhenLimitIsBroke = (fovMode, angle, { aov: { min, max, minVertical, maxVertical } }) => {
    if (fovMode === CORRIDOR) {
      if (angle < minVertical) return minVertical
      else if (angle > maxVertical) return maxVertical
    } else {
      if (angle < min) return min
      else if (angle > max) return max
    }
  }

  calculateMaxVertexAndUpdateMarker = (side, angle) => {
    const { distance, cameraMarkerPosition, heading } = this.props
    const positions = calculateVertex({ angle, distance, cameraMarkerPosition, heading })
    this[`${side}Marker`].setPosition(positions[`${side}Position`])
  }

  calculateMarkersLocation = (latLng, side) => {
    const { heading, cameraMarkerPosition, distance } = this.props

    let markerHeading = google.maps.geometry.spherical.computeHeading(cameraMarkerPosition, latLng)
    if (markerHeading < heading - 90) markerHeading = 2 * heading - 180 - markerHeading
    else if (markerHeading > heading + 90) markerHeading = 2 * heading + 180 - markerHeading
    const otherHeading = 2 * heading - markerHeading

    // calculate and return next marker positions
    return {
      pos: google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, distance, side === 'left' ? markerHeading : otherHeading),
      oppositePos: google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, distance, side === 'left' ? otherHeading : markerHeading),
    }
  }

  calculateAngleOfView = (angleMarkerPosition, oppositeAngleMarkerPosition) => {
    const markerDistance = google.maps.geometry.spherical.computeDistanceBetween(angleMarkerPosition, oppositeAngleMarkerPosition)
    return toDegree(2 * Math.asin(markerDistance / 2 / this.props.distance))
  }

  componentWillReceiveProps = newProps => {
    const { paths: { leftPosition, rightPosition }, visible, locked } = newProps
    if (this.props.paths.leftPosition.lat() !== leftPosition.lat() ||
        this.props.paths.leftPosition.lng() !== leftPosition.lng() ||
        this.props.paths.rightPosition.lat() !== rightPosition.lat() ||
        this.props.paths.rightPosition.lng() !== rightPosition.lng()) {
      this.leftMarker.setPosition(leftPosition)
      this.rightMarker.setPosition(rightPosition)
    }

    if (this.props.visible !== visible || this.props.locked !== locked) {
      this.leftMarker.setVisible(this.isVisible(newProps))
      this.rightMarker.setVisible(this.isVisible(newProps))
    }
  }

  isVisible = ({ visible, locked }) => !locked && visible && !EXPORT

  shouldComponentUpdate = _ => false

  render = _ => null
}

export default (AngleMarkers)



// WEBPACK FOOTER //
// ./src/components/Camera/AngleMarkers.js